<script>
  import { _ } from 'svelte-i18n'
  import { modals } from '../../stores';
  import Button from '../../elements/Button.svelte';
  import Modal from '../../elements/Modal.svelte'

  let modal_id = 'passwordTokenExpired'
</script>

<Modal id={modal_id}>
  <span slot="header">
    {$_('modals.passwordTokenExpired.title')}
  </span>
  <span class="content" slot="content">
    <p>{$_('modals.passwordTokenExpired.detail1')}</p>
    <p>{$_('modals.passwordTokenExpired.detail2')}</p>
  </span>
  <span slot="footer">
    <div class="button_wrapper">
      <Button kind="outline" on:click={() => modals.open('forgotPassword')}>Reset Password Again</Button>
    </div> 
  </span>
</Modal>

<style>
  .content :global(p) {
    margin-bottom: 1rem;
  }
  .button_wrapper {
    margin-top: 2rem;
  }
</style>